var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "cancel-disabled": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        title: _vm.$t("consolidate-modal.title")
      },
      on: { show: _vm.loadBillableEntities },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { white: "", shadow: "" },
                      on: { click: _vm.consolidate }
                    },
                    [_vm._v(_vm._s(_vm.$t("continue")))]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.isBillable
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("consolidate-modal.charge-with-data")))
                ]),
                _vm._v(" "),
                _c("base-select", {
                  attrs: {
                    disabled: _vm.noChargeSelectedReasonIsTechnicalType,
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-billable-entity"
                    ),
                    options: _vm.billingEntities
                  },
                  model: {
                    value: _vm.selectedBillableEntity,
                    callback: function($$v) {
                      _vm.selectedBillableEntity = $$v
                    },
                    expression: "selectedBillableEntity"
                  }
                }),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { onInput: _vm.noChargeToggled },
                    model: {
                      value: _vm.noChargeCheckboxValue,
                      callback: function($$v) {
                        _vm.noChargeCheckboxValue = $$v
                      },
                      expression: "noChargeCheckboxValue"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("consolidate-appointment-modal.no-charge")
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("base-select", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.noChargeCheckboxValue,
                      expression: "noChargeCheckboxValue"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "consolidate-appointment-modal.select-no-charge-reason"
                    ),
                    options: _vm.noChargeOptions
                  },
                  model: {
                    value: _vm.noChargeSelectedReason,
                    callback: function($$v) {
                      _vm.noChargeSelectedReason = $$v
                    },
                    expression: "noChargeSelectedReason"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bd54cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72bd54cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/shared/ConsolidateAppointmentModal.vue
// module id = 3117
// module chunks = 14 145